




















































































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { column, userTableItem, userInfo } from '../interface/'
import { userTableColumns } from '../config/'
import {
  queryAllUsers,
  queryUserListWithGroup,
  getUserInfo,
  queryCurrentUserGroupList,
  updateUserGroup,
  changeUserStatus,
  getCurrentUserInfo,
  updateUserInfoTel,
  updateUserInfoEmail,
  queryGroups
} from '../../../service/settings'

@Component
export default class UserManage extends Vue {
  isButtonsDisabled: boolean = true
  adminName: string = ''
  adminInfoPhone: string = ''
  isPhoneVisible: boolean = true
  adminInfoEmail: string = ''
  isEmailVisible: boolean = true
  adminGroups: any[] = []
  adminLoginHistory: any[] = []
  isUserTableVisible: boolean = true
  isUserDetailsVisible: boolean = false
  isEditVisible: boolean = false
  isAdminInfoVisible: boolean = false
  userTableColumns: column[] = userTableColumns
  userTableDataSource: userTableItem[] = []
  userInfo: userInfo = {}
  groupList: string[] = []
  options: any[] = []
  checkedList: string[] = []
  selectedRowKeys: string[] = []
  userList: string[] = []
  public searchValue: string = ''
  public groups = []
  public pagination = {
    total: 0,
    current: 1,
    showTotal: (total) => `共 ${total} 条`
  }
  @Watch('selectedRowKeys')
  public onSelectedKeysChange(newVal, oldVal) {
    this.isButtonsDisabled = newVal.length === 0
  }
  public onSelectChange(selectedRowKeys, selectedRows) {
    this.selectedRowKeys = selectedRowKeys
    this.userList = selectedRows.map((item) => {
      return item.id
    })
  }
  public async mounted() {
    const query = this.$route.query
    if (query.admin) {
      this.isAdminInfoVisible = true
    } else {
      this.renderUserList(1)
    }
    const res = await getCurrentUserInfo()
    this.adminInfoPhone = res.tel_no
    this.adminInfoEmail = res.email ? res.email : ''
    this.adminGroups = res.perm_groups
    this.adminLoginHistory = res.login_history
    this.adminName = `用户名：${res.username}`
    this.groups = res.perm_groups
  }
  public async togglePhone(e) {
    if (!this.isPhoneVisible) {
      const adminInfoPhone = this.adminInfoPhone
      await updateUserInfoTel(adminInfoPhone)
    }
    this.isPhoneVisible = !this.isPhoneVisible
  }
  public async toggleEmail(e) {
    if (!this.isEmailVisible) {
      const adminInfoEmail = this.adminInfoEmail
      await updateUserInfoEmail(adminInfoEmail)
    }
    this.isEmailVisible = !this.isEmailVisible
  }
  public async renderUserList(current) {
    const value = this.searchValue
    const { list, total } = await queryUserListWithGroup(value, current, 10)
    this.userTableDataSource = list
    this.pagination.current = current
    this.pagination.total = total
  }
  public async showUserDetails(name) {
    this.userInfo = await getUserInfo(name)
    this.isUserTableVisible = false
    this.isUserDetailsVisible = true
  }
  public defaultOptions: string[] = []
  public async changeGroup(e) {
    this.isEditVisible = true
    this.isUserDetailsVisible = false
    const { id } = this.userInfo
    if (id) {
      const options = {
        user_id: id
      }
      const list = await queryGroups(options)
      this.options = list.map((item: any) => {
        return {
          label: item.name,
          value: item.id,
          checked: item.checked
        }
      })
      list.forEach((item: any) => {
        if (item.checked) {
          this.checkedList.push(item.id)
        }
      })
    }
  }
  public async addGroups(e) {
    const { id } = this.userInfo
    const group_ids = this.checkedList.join(',')
    if (id) {
      await updateUserGroup(group_ids, id)
      this.isUserTableVisible = true
      this.isEditVisible = false
      this.isUserDetailsVisible = false
      this.renderUserList(1)
    }
  }
  public async activateUser(e) {
    await changeUserStatus('1', this.userList)
    this.selectedRowKeys = []
    await this.renderUserList(1)
  }
  public async forbiddenUser(e) {
    await changeUserStatus('0', this.userList)
    this.selectedRowKeys = []
    await this.renderUserList(1)
  }
  public onSearchUsers(value) {
    this.renderUserList(1)
  }
  public handleTableChange(pagination, filters, sorter) {
    this.renderUserList(pagination.current)
    this.selectedRowKeys = []
  }
  public backToMainList(e) {
    this.isUserTableVisible = true
    this.isUserDetailsVisible = false
  }
}
